import { render, staticRenderFns } from "./EventManagementPlugin.vue?vue&type=template&id=0a37c152&"
import script from "./EventManagementPlugin.vue?vue&type=script&lang=ts&"
export * from "./EventManagementPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports